import React from "react";
import { FaArrowRightLong } from "react-icons/fa6";

const ToolComponent = () => {
  return (
    <div className="maxW-full my-36 sm:my-48">
      <div className=" w-[100%] sm:[90%] flex flex-col  sm:shadow-md ">
        <div className="w-[85%]  mx-auto ">
          <h1 className=" w-[100%] sm:w-[85%] text-3xl md:text-5xl text-center font-medium md:font-semibold text-gray-800 mx-auto">
            A combinationof tools to design and develop modern application at
            ease.
          </h1>
        </div>
        <div className="w-[95%] sm:w-[55%] flex flex-col sm:flex-row gap-4 justify-between items-center mx-auto my-28  ">
          <div className="h-[350px] flex flex-col items-start gap-8 shadow-lg rounded-lg p-4">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="36"
              height="32"
              viewBox="0 0 36 32"
            >
              <g fill="none">
                <polygon
                  fill="#FDB300"
                  points="17.655 0 7.704 1.052 0 11.394 17.655 31.953 35.31 11.394 27.606 1.052"
                />
                <path
                  fill="#EB6C00"
                  d="M0,11.3942069 L17.6551724,31.9533793 L7.15117241,11.3942069 L0,11.3942069 Z M28.1590345,11.3942069 L17.6551724,31.9533793 L35.3103448,11.3942069 L28.1590345,11.3942069 Z"
                />
                <polygon
                  fill="#FDAD00"
                  points="7.151 11.394 17.655 31.953 28.159 11.394"
                />
                <path
                  fill="#FDD231"
                  d="M7.70413793,1.05213793 L7.15103448,11.3942069 L17.6551724,0 L7.70413793,1.05213793 Z M28.1590345,11.3942069 L27.6062069,1.05213793 L17.6551724,0 L28.1590345,11.3942069 Z"
                />
                <path
                  fill="#FDAD00"
                  d="M28.1591724,11.3942069 L35.3103448,11.3942069 L27.6063448,1.05213793 L28.1591724,11.3942069 Z M0,11.3942069 L7.15117241,11.3942069 L7.70413793,1.05213793 L0,11.3942069 Z"
                />
                <polygon
                  fill="#FEEEB7"
                  points="17.655 0 7.151 11.394 28.159 11.394"
                />
              </g>
            </svg>

            <div className="flex flex-col items-start">
              <h2 className="text-2xl font-semibold my-4">Design</h2>
              <p className="w-[75%] text-gray-500 text-start  ">
                Design your website by using Atomize for Sketch App.
              </p>
            </div>
            <div className=" group flex cursor-pointer ">
              <button className="text-sky-600  group-hover:text-sky-300">
                Design Resource{" "}
              </button>
              <FaArrowRightLong className="m-auto ml-9 text-sky-600 group-hover:text-sky-300" />
            </div>
          </div>

          <div className="h-[350px] flex flex-col items-start gap-8 shadow-lg rounded-lg p-4">
            <svg
              width="36"
              height="36"
              viewBox="0 0 256 228"
              xmlns="http://www.w3.org/2000/svg"
              preserveAspectRatio="xMidYMid"
            >
              <path
                d="M210.483 73.824a171.49 171.49 0 0 0-8.24-2.597c.465-1.9.893-3.777 1.273-5.621 6.238-30.281 2.16-54.676-11.769-62.708-13.355-7.7-35.196.329-57.254 19.526a171.23 171.23 0 0 0-6.375 5.848 155.866 155.866 0 0 0-4.241-3.917C100.759 3.829 77.587-4.822 63.673 3.233 50.33 10.957 46.379 33.89 51.995 62.588a170.974 170.974 0 0 0 1.892 8.48c-3.28.932-6.445 1.924-9.474 2.98C17.309 83.498 0 98.307 0 113.668c0 15.865 18.582 31.778 46.812 41.427a145.52 145.52 0 0 0 6.921 2.165 167.467 167.467 0 0 0-2.01 9.138c-5.354 28.2-1.173 50.591 12.134 58.266 13.744 7.926 36.812-.22 59.273-19.855a145.567 145.567 0 0 0 5.342-4.923 168.064 168.064 0 0 0 6.92 6.314c21.758 18.722 43.246 26.282 56.54 18.586 13.731-7.949 18.194-32.003 12.4-61.268a145.016 145.016 0 0 0-1.535-6.842c1.62-.48 3.21-.974 4.76-1.488 29.348-9.723 48.443-25.443 48.443-41.52 0-15.417-17.868-30.326-45.517-39.844zm-6.365 70.984c-1.4.463-2.836.91-4.3 1.345-3.24-10.257-7.612-21.163-12.963-32.432 5.106-11 9.31-21.767 12.459-31.957 2.619.758 5.16 1.557 7.61 2.4 23.69 8.156 38.14 20.213 38.14 29.504 0 9.896-15.606 22.743-40.946 31.14zm-10.514 20.834c2.562 12.94 2.927 24.64 1.23 33.787-1.524 8.219-4.59 13.698-8.382 15.893-8.067 4.67-25.32-1.4-43.927-17.412a156.726 156.726 0 0 1-6.437-5.87c7.214-7.889 14.423-17.06 21.459-27.246 12.376-1.098 24.068-2.894 34.671-5.345.522 2.107.986 4.173 1.386 6.193zM87.276 214.515c-7.882 2.783-14.16 2.863-17.955.675-8.075-4.657-11.432-22.636-6.853-46.752a156.923 156.923 0 0 1 1.869-8.499c10.486 2.32 22.093 3.988 34.498 4.994 7.084 9.967 14.501 19.128 21.976 27.15a134.668 134.668 0 0 1-4.877 4.492c-9.933 8.682-19.886 14.842-28.658 17.94zM50.35 144.747c-12.483-4.267-22.792-9.812-29.858-15.863-6.35-5.437-9.555-10.836-9.555-15.216 0-9.322 13.897-21.212 37.076-29.293 2.813-.98 5.757-1.905 8.812-2.773 3.204 10.42 7.406 21.315 12.477 32.332-5.137 11.18-9.399 22.249-12.634 32.792a134.718 134.718 0 0 1-6.318-1.979zm12.378-84.26c-4.811-24.587-1.616-43.134 6.425-47.789 8.564-4.958 27.502 2.111 47.463 19.835a144.318 144.318 0 0 1 3.841 3.545c-7.438 7.987-14.787 17.08-21.808 26.988-12.04 1.116-23.565 2.908-34.161 5.309a160.342 160.342 0 0 1-1.76-7.887zm110.427 27.268a347.8 347.8 0 0 0-7.785-12.803c8.168 1.033 15.994 2.404 23.343 4.08-2.206 7.072-4.956 14.465-8.193 22.045a381.151 381.151 0 0 0-7.365-13.322zm-45.032-43.861c5.044 5.465 10.096 11.566 15.065 18.186a322.04 322.04 0 0 0-30.257-.006c4.974-6.559 10.069-12.652 15.192-18.18zM82.802 87.83a323.167 323.167 0 0 0-7.227 13.238c-3.184-7.553-5.909-14.98-8.134-22.152 7.304-1.634 15.093-2.97 23.209-3.984a321.524 321.524 0 0 0-7.848 12.897zm8.081 65.352c-8.385-.936-16.291-2.203-23.593-3.793 2.26-7.3 5.045-14.885 8.298-22.6a321.187 321.187 0 0 0 7.257 13.246c2.594 4.48 5.28 8.868 8.038 13.147zm37.542 31.03c-5.184-5.592-10.354-11.779-15.403-18.433 4.902.192 9.899.29 14.978.29 5.218 0 10.376-.117 15.453-.343-4.985 6.774-10.018 12.97-15.028 18.486zm52.198-57.817c3.422 7.8 6.306 15.345 8.596 22.52-7.422 1.694-15.436 3.058-23.88 4.071a382.417 382.417 0 0 0 7.859-13.026 347.403 347.403 0 0 0 7.425-13.565zm-16.898 8.101a358.557 358.557 0 0 1-12.281 19.815 329.4 329.4 0 0 1-23.444.823c-7.967 0-15.716-.248-23.178-.732a310.202 310.202 0 0 1-12.513-19.846h.001a307.41 307.41 0 0 1-10.923-20.627 310.278 310.278 0 0 1 10.89-20.637l-.001.001a307.318 307.318 0 0 1 12.413-19.761c7.613-.576 15.42-.876 23.31-.876H128c7.926 0 15.743.303 23.354.883a329.357 329.357 0 0 1 12.335 19.695 358.489 358.489 0 0 1 11.036 20.54 329.472 329.472 0 0 1-11 20.722zm22.56-122.124c8.572 4.944 11.906 24.881 6.52 51.026-.344 1.668-.73 3.367-1.15 5.09-10.622-2.452-22.155-4.275-34.23-5.408-7.034-10.017-14.323-19.124-21.64-27.008a160.789 160.789 0 0 1 5.888-5.4c18.9-16.447 36.564-22.941 44.612-18.3zM128 90.808c12.625 0 22.86 10.235 22.86 22.86s-10.235 22.86-22.86 22.86-22.86-10.235-22.86-22.86 10.235-22.86 22.86-22.86z"
                fill="#87CEEB"
              />
            </svg>

            <div className="flex flex-col items-start">
              <h2 className="text-2xl font-semibold my-4">Development</h2>
              <p className=" text-gray-500 text-start  ">
                Bring your designs to life with Atomize for React JS.
              </p>
            </div>

            <div className="flex cursor-pointer group">
              <button className="text-sky-600 group-hover:text-sky-300">
                Documentation{" "}
              </button>
              <FaArrowRightLong className="m-auto ml-9 text-sky-600 group-hover:text-sky-300" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ToolComponent;
